// Měří aktuální výšku .site-msg.information a propisuje ji do --site-msg-h na body.
// Důvod: na mobilu se text v liště zalamuje na proměnný počet řádků (1–4), takže fixní
// hodnota v SCSS by buď nestačila (obsah by lezl pod lištu) nebo by zbytečně přidávala mezeru.
// CSS proměnná pak řídí padding-top na body (viz style.scss).

function updateSiteMsgHeight() {
    const $bar = $(".site-msg.information");

    if ($bar.length && $bar.is(":visible")) {
        document.body.style.setProperty("--site-msg-h", $bar[0].offsetHeight + "px");
    } else {
        document.body.style.removeProperty("--site-msg-h");
    }
}

let resizeTimer;

function debouncedUpdate() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(updateSiteMsgHeight, 100);
}

$(document).ready(function () {
    if (!$(".site-msg.information").length) return;

    updateSiteMsgHeight();
    $(window).on("resize", debouncedUpdate);

    // Při kliknutí na zavírátko Shoptet po fadeOut (~400 ms) lištu remove-uje.
    // Doměříme po 700 ms a CSS :has() pak přestane platit, padding se uvolní.
    $(document).on("click", ".js-close-information-msg", function () {
        setTimeout(updateSiteMsgHeight, 700);
    });
});

// Po načtení fontů se může text zalomit jinak — re-měříme.
if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(updateSiteMsgHeight);
}
